import { Check } from 'lucide-react'
import { forwardRef, type ButtonHTMLAttributes } from 'react'
import { MicrosoftProviderIcon } from '@/components/shared/MicrosoftProviderIcon'
import { cn } from '@/lib/utils'
import type { SyncProvider } from './syncProviders'

interface SyncProviderCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  provider: SyncProvider
  selected?: boolean
}

export const SyncProviderCard = forwardRef<HTMLButtonElement, SyncProviderCardProps>(
  function SyncProviderCard({ provider, selected = false, className, ...props }, ref) {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'w-full rounded-lg border p-4 text-left transition-colors',
          selected
            ? 'border-blue-300 bg-blue-50'
            : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50',
          className
        )}
        {...props}
      >
        <div className="flex items-center gap-3">
          <div className="text-2xl flex shrink-0 items-center justify-center w-8 h-8">
            {provider.type === 'onedrive' ? (
              <MicrosoftProviderIcon provider="onedrive" className="h-8 w-8" />
            ) : provider.type === 'sharepoint' ? (
              <MicrosoftProviderIcon provider="sharepoint" className="h-8 w-8" />
            ) : provider.icon.startsWith('/') ? (
              <img
                src={provider.icon}
                alt={`${provider.name} logo`}
                className="w-8 h-8 object-contain"
              />
            ) : (
              provider.icon
            )}
          </div>
          <div className="flex-1">
            <div className="font-semibold text-base">{provider.name}</div>
            <div className="text-sm text-gray-600 mt-1">
              {provider.description}
            </div>
          </div>
          {selected && (
            <Check className="h-5 w-5 text-blue-600 shrink-0" />
          )}
        </div>
      </button>
    )
  }
)
